import { archiveItem } from "@/components/page/Archive";
import { IHttpRequest } from  "@/interfaces/IHttp";
import { container, TYPES } from  "@/inversifyconfig/container.config";

const http = container.get<IHttpRequest>(TYPES.IHttpRequest); 

export async function getArchivedItemById(contentId: number): Promise<archiveItem> {
    const res = await http.get(`content/archived/${contentId}`);
    
    if(res.data) {
        return Promise.resolve(res.data)
    } 
    return Promise.reject(new Error(`Couldn't get menu items list`))
}

export async function restoreArchivedCotent(appId: number, archivedItem: archiveItem) {
    const restorePayload = {
        appId: appId,
        parentId: archivedItem?.parentListIdPriorToArchiving ?? undefined,
        contentId: archivedItem?.id,
        position: "",
        publish : true
    }     
     
    return http.post(`content/restore`, restorePayload)
}